import { buildQuery } from '@calendly/http-tools';
import { BareButton } from '@calendly/ui/components/bare-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { HighlightedText } from '../utils';
const containerCss = "c1odbwjj";
const Container = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const contentWrapperCss = "c1h70t36";
const ContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentWrapperCss, props.className)} />;
});
const transcriptTextCss = "tn953wk";
const TranscriptText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(transcriptTextCss, props.className)} />;
});
export const TranscriptMatch = ({
  match,
  trackedMeetingUuid,
  handleClick
}) => {
  const url = `/app/tracked_meetings/${trackedMeetingUuid}?${buildQuery({
    t: match.startTime
  })}`;
  const clickWrapper = e => {
    handleClick(e, url, 'click_result_transcript');
  };
  return <Container onClick={clickWrapper}>
      <ContentWrapper>
        <BodyText weight="bold" size="medium">
          {match.name}
        </BodyText>
        <BodyText color="muted" size="x-small">
          {match.timestamp}
        </BodyText>
        <TranscriptText>
          <HighlightedText html={match.text} />
        </TranscriptText>
      </ContentWrapper>
    </Container>;
};

require("./transcript_match.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./transcript_match.js");